<template>
  <div class="container flex">
    <div id="test" class="flex1 ml10">
      <div class="content " style="position: relative;">
        <div
          class="canvas"
          ref="can2"
          :style="{
            transform: 'scale(' + num + ')',
            position: 'absolute',
            height: '100%',
            width: '100%',
          }"
          @mousewheel="suo"
          @mousemove="moveMouse"
          v-if="dwImg"
        >
          <crtmarker ref="aiPanelEditor1" :isBZ="true" :imgUrl="dwImg" :idx="1" />
        </div>
      </div>
      <div class="rightnav" style="width: 29%; height: 91%">
        <div style="width: 100%" class="center">
          <el-col :span="24">
            <el-input placeholder="请输入部位号或名称查询" clearable v-model="rightParams.true_addr" prefix-icon="el-icon-search"></el-input>
          </el-col>
          <el-col :span="5">
            <el-button type="primary" class="ml10" style="margin-top: 0px" size="small" @click="searchRight">查询</el-button>
          </el-col>
          <el-col :span="5">
            <el-button class="ml10" style="margin-top: 0px" size="small" @click="reset">重置</el-button>
          </el-col>
        </div>
        <div style="width: 100%;height: 100%;">
          <el-table :data="qvyuList" class="mt10" height="640">
            <el-table-column prop="number" label="部位号" align="center"> </el-table-column>
            <el-table-column prop="true_addr" label="设备名称" align="center"> </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { AIMarker } from "vue-picture-bd-marker";
import crtmarker from '../../components/crtmarker';

import { getMapByid } from '../../api/common';
import config from '../../utils/config.js';

export default {
  props: ['isShow', 'it', 'nowDevice'],
  components: {
    crtmarker,
  },
  data() {
    return {
      num: 1,
      isdraged: false,
      add: false, //是否新增变化
      typeList: [], // 点位类型
      company: '', // 当前查询的公司
      companyList: [], //公司列表

      companyList1: [], //查询到的公司列表
      qvyuList: [], //区域列表
      pointList: [], //点位列表
      comara: false, //点位摄像头
      videoList: [], // 摄像头列表
      selectPoint: {}, // 选中的点位
      selectcomp: '',
      videoIndex: 0,
      playUrl: '',
      rightParams: {
        area_uuid: '',
        c_number: '',
        point_type: 274,
        true_addr: '',
        page: 1,
        number: '',
      },
      rightNum: 10,
      warning: false,
      nowMessage: {},
      videoAddr: '',
      form: {}, //最终确定的点位
      dwImg: '',
      radio1: '',
      isAlarm: true,
      isSomke: true,
    };
  },
  watch: {
    it(val) {
      if (val) this.checkCop(val);
    },
    comara(val) {
      if (!val) {
        this.videoList = [];
      }
    },
  },
  created() {},
  methods: {
    changeFireStatus(isWaring, item) {
      this.warning = isWaring;
      this.nowMessage = item;
      this.startAnimate();
    },

    reset() {
      this.rightParams.number = '';
      this.rightParams.true_addr = '';
      this.getdwList();
    },
    searchRight() {
      this.rightParams.number = this.rightParams.true_addr;
      this.getdwList();
    },

    // 搜素单位
    searchcomp() {
      this.companyList1 = [];
      if (!this.company) {
        return;
      }
      if (this.companyList.length) {
        this.companyList.map((item) => {
          if (item.company.indexOf(this.company) > -1) {
            this.companyList1.push(item);
          }
        });
      }
      (this.companyList1.length > 0 ? this.companyList1 : this.companyList)?.forEach((item) => {
        item.data[0] && this.checkCop(item.data[0]);
      });
    },

    //获取点位
    getdwList() {
      // console.log(this.rightParams);
      this.$post('/crt/crtSmoke', this.rightParams).then((res) => {
        var companylist = [];
        var pointList = [];
        this.rightNum = res.data.count;
        res.data.list.map((item) => {
          var obj1 = {
            number: item.number,
            true_addr: item.true_addr,
            point_uuid: item.point_uuid,
            id: item.id,
            isMark: item.x_axis ? true : false,
          };
          var obj2 = {
            tag: item.number,
            tagName: `<div>
                       部位名称：${item.true_addr}<br/>
                       部位编号：${item.number}
                      </div>`,

            x: item.x_axis,
            y: item.y_axis,
            type: item.point_type,
            point_uuid: item.point_uuid,
          };
          companylist.push(obj1);
          pointList.push(obj2);
        });
        this.qvyuList = companylist;
        this.pointList = pointList;
        // console.log(this.pointList);
        // this.$refs['aiPanelEditor1']?.remove();
        this.$refs['aiPanelEditor1']?.getBiaozhu(this.pointList);
        // this.changeFireStatus(this.warning, this.nowMessage);
      });
    },

    // 选择区域的点
    checkCop(it) {
      // this.it = it;
      // this.$refs["aiPanelEditor1"]?.remove();
      this.pointList = [];
      this.rightParams.area_uuid = it.area_uuid;
      this.rightParams.page = 1;
      this.rightParams.c_number = it.c_number;
      this.dwImg = it.image_name;
      this.getdwList();
    },

    //滚轮缩小放大
    suo(v) {
      this.num -= -((v.wheelDelta ? v.wheelDelta : v.deltaY) / 1000);
      if (this.num < 0) {
        this.num = 0.1;
      }
    },

    moveMouse(e) {
      if (!this.isdraged) {
        var ooid = this.$refs.can2; //获取目标元素
        // 鼠标按下的时候 获取坐标
        ooid.onmousedown = function(event) {
          // console.log(event, 'set position');
          var dx = event.clientX - ooid.offsetLeft;
          var dy = event.clientY - ooid.offsetTop;

          // 鼠标拖拽的时候
          ooid.onmousemove = function(event) {
            //绑定元素位置到positionX和positionY上面
            event = event || window.event;
            var left = event.clientX;
            var top = event.clientY;
            //移动当前元素
            ooid.style.left = left - dx + 'px';
            ooid.style.top = top - dy + 'px';
          };

          // 清除鼠标事件
          ooid.onmouseup = function() {
            ooid.onmousemove = null;
            ooid.onmouseup = null;
          };
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.selectVideo {
  border: solid 2px red;
  height: 500px;
  width: 600px;
  position: relative;
}
::v-deep .selected {
  z-index: 99999;
}
::v-deep .g-image-op {
  background: #fff;
  border: 1px solid #ccc;
  bottom: 110%;
  display: none;
}
::v-deep .g-image-op-del {
  display: none;
}
::v-deep .g-image-op-content {
  height: auto;
}
::v-deep .annotation {
  background: #000;
  border: none;
  /* animation: dianmove 0.5s infinite; */
  border-radius: 50%;
  /* border: none; */
}
::v-deep .animate {
  animation: warningmove 0.6s infinite;
  position: absolute !important;
  /* z-index: 999999; */
}

@keyframes warningmove {
  from {
    background: yellow;
  }
  to {
    background: #ed1c24;
  }
}
.canvas {
  display: flex;
  align-items: center;
}
.container {
  width: 100%;
  max-height: 41.5vw;
  height: 100%;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  .topnav {
    height: 20%;
  }
  .leftNav {
    height: 100%;
    max-width: 23%;
  }
  #test {
    height: 100%;
    position: relative;
    .el-dialog__body {
      padding: 10px 20px !important;
    }
    .content {
      width: 70%;
      height: 100%;
      background: #000;

      overflow: hidden;
      border: 1px solid gray;
    }
  }
}

::v-deep .el-tab-pane {
  width: 100%;
  height: 43.75rem;
  margin: auto 0;
  display: flex;
}
.rightnav {
  width: 30%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
}
</style>
